import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import system from './modules/system'
import scanCode from './modules/scanCode'



Vue.use(Vuex)

//严格模式:只能通过mutations更改state的值
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	//注册模块
	modules: {
		user,
		system,
		scanCode,
    
	},
	//定义严格模式
	strict: debug,
})



// WEBPACK FOOTER //
// ./src/store/index.js